import { Component, PlateTypeProperties } from '@paragon/contract-library';

import { DesignService } from './connections';

export interface UploadFile {
  readonly name: string;
  readonly fileType: string;
  readonly base64Contents: string;
}

type ActionFailedOn = 'Parse' | 'Write' | 'Compare';

export interface ConversionFailure {
  readonly guid: string;
  readonly actionFailedOn: ActionFailedOn;
  readonly exception: unknown;
}

export interface FailedFileConversion extends ConversionFailure {
  readonly name: string;
  readonly fileType: string;
}

interface ConvertResult {
  readonly guid: string;
  readonly convertedFilesZipUrl: string | null;
  readonly failedConversions: readonly ConversionFailure[];
}

export async function convert(convertToFileType: string, files: readonly UploadFile[]) {
  return DesignService.post<ConvertResult>('convertutilities/convert', {
    data: {
      convertToFileType,
      files,
    },
  });
}

export function updateQuantities(files: readonly UploadFile[]) {
  return DesignService.fetchFile('countutilities/updateTreQuantities', { post: true, data: { files } });
}

export async function sequencePlates(files: readonly UploadFile[]) {
  return DesignService.fetchFile('plateSequences/sequencePlates', { post: true, data: { files } });
}

export async function countMaterials(files: readonly UploadFile[]) {
  return DesignService.fetchFile('countutilities/countMaterials', { post: true, data: { files } });
}

export async function countComponents(files: readonly UploadFile[]) {
  return DesignService.fetchFile('countutilities/countComponents', { post: true, data: { files } });
}

interface BatchResult {
  readonly guid: string;
  readonly batchResultsUrl: string;
}

export async function batch(files: readonly UploadFile[]) {
  return DesignService.post<BatchResult>('batchutilities/batch', { data: { files } });
}

interface ComparisonResult {
  readonly diff: string;
  readonly set1FileType: string;
  readonly set1Component: Component;
  readonly set2FileType: string;
  readonly set2Component: Component;
  readonly plateTypeProperties: { [getPlateTypeStringResult: string]: PlateTypeProperties | undefined };
}

export interface CompareResult {
  readonly comparisons: { [fileName: string]: ComparisonResult };
  readonly failedFiles: readonly FailedFileConversion[];
}

export async function compare(fileSetOne: readonly UploadFile[], fileSetTwo: readonly UploadFile[]) {
  return DesignService.post<CompareResult>('compareutilities/compare', {
    data: {
      fileSet1: fileSetOne,
      fileSet2: fileSetTwo,
    },
  });
}
